import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { withParams } from '@telialt/utils/src/helpers';

import { ORDER_CART_ENTRY_ID, ORDER_CART_TEST_ID } from '../constants';
import { Price } from '../model';
import {
    CellIcon,
    CellPrice,
    CellTitle,
    MobRatePlanEntryListItem,
    Row,
    RowPhone,
    RowPhoneValue,
    RowSecondary,
    Separator,
} from './entries.styles';

type MobRatePlanEntryProps = {
    name: string;
    monthlyPrice: Price;
    commitmentText?: string;
    phoneNumber?: string;
    callsAndSmsAllowance?: string;
    dataAllowanceDomestic?: string;
    dataAllowanceForeign?: string;
};

export const MobRatePlanEntry: FC<MobRatePlanEntryProps> = ({
    name,
    monthlyPrice,
    commitmentText,
    phoneNumber,
    callsAndSmsAllowance,
    dataAllowanceDomestic,
    dataAllowanceForeign,
}) => {
    const { t } = useTranslations();
    const planName = name ? withParams(t['order_cart.entry_rate_plan.plan_name'], { name }) : undefined;

    return (
        <MobRatePlanEntryListItem data-test={ORDER_CART_ENTRY_ID.MOB_RATE_PLAN} aria-label={planName}>
            <CellIcon icon="doc" />
            <CellTitle data-test={ORDER_CART_TEST_ID.ENTRY_TITLE_RATE_PLAN}>{dataAllowanceDomestic}</CellTitle>
            <CellPrice price={monthlyPrice} isMonthly={true} dataTest={ORDER_CART_TEST_ID.PRICE_RATE_PLAN} />
            <Separator />

            <Row>{callsAndSmsAllowance}</Row>
            <Row>{planName}</Row>
            <Row>{dataAllowanceForeign}</Row>

            <RowSecondary>{commitmentText}</RowSecondary>
            {!!phoneNumber && (
                <>
                    <RowPhone>{t['order_cart.entry_rate_plan.phone_number_label']}</RowPhone>
                    <RowPhoneValue>{phoneNumber}</RowPhoneValue>
                </>
            )}
        </MobRatePlanEntryListItem>
    );
};
